import { TableCell, TableRow, Tooltip } from '@mui/material';
import { FC, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { MarketCategory } from '../../../app/services/api/orderManagementClient';
import { useTranslation } from 'react-i18next';
import { UserContext } from '../../../components/shared/useUser';

type Props = {
  category: MarketCategory;
  parentCategories: MarketCategory[];
  instanceName: string;
};

const CategoryItemRow: FC<Props> = ({ category, parentCategories, instanceName }) => {
  const { t } = useTranslation('categories');
  const navigate = useNavigate();
  const { hasPermissionTo } = useContext(UserContext);

  const canEdit = hasPermissionTo(['ConfigurationAdmin']) || hasPermissionTo(['CategoryUpdate']);

  const handleRowClick = () => {
    if (!canEdit) return;
    navigate(`/categories/edit/${category.categoryId}?companyId=${category.companyId}`);
  };

  const truncateText = (text: string, maxLength: number = 30) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  const getParentCategoryName = (parentId: number) => {
    if (parentId <= 0) return t('none');
    const parent = parentCategories.find(cat => cat.categoryId === parentId);
    return parent ? parent.name : '-';
  };

  return (
    <TableRow
      onClick={canEdit ? handleRowClick : undefined}
      sx={{
        cursor: canEdit ? 'pointer' : 'default',
        '&:hover': canEdit ? {
          backgroundColor: 'action.hover',
        } : undefined,
      }}
    >
      <TableCell>
        <Tooltip 
          title={category.name} 
          placement="top"
        >
          <span>{truncateText(category.name)}</span>
        </Tooltip>
      </TableCell>
      <TableCell>
        <Tooltip 
          title={getParentCategoryName(category.parentId)} 
          placement="top"
        >
          <span>{truncateText(getParentCategoryName(category.parentId))}</span>
        </Tooltip>
      </TableCell>
      <TableCell>
        <Tooltip 
          title={instanceName} 
          placement="top"
        >
          <span>{truncateText(instanceName)}</span>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default CategoryItemRow;
